__turbopack_context__.v({
  "desktopContainer": "V2EnterLayout-module__9GHgrG__desktopContainer",
  "desktopLeft": "V2EnterLayout-module__9GHgrG__desktopLeft",
  "desktopLeftInner": "V2EnterLayout-module__9GHgrG__desktopLeftInner",
  "desktopRight": "V2EnterLayout-module__9GHgrG__desktopRight",
  "desktopRightFooter": "V2EnterLayout-module__9GHgrG__desktopRightFooter",
  "desktopRightInner": "V2EnterLayout-module__9GHgrG__desktopRightInner",
  "mobileBottom": "V2EnterLayout-module__9GHgrG__mobileBottom",
  "mobileTop": "V2EnterLayout-module__9GHgrG__mobileTop",
});
